import { StoreState } from 'src/store/reducers';

export const Selector = (state: StoreState) => state.cases.data.list;

export const miniLoaderForSelector = (state: StoreState) => state.cases.miniLoaderFor;
